<ng-container [ngSwitch]="modeLogin">
    <ng-container *ngSwitchCase="'2'" [ngTemplateOutlet]="myconfirm"></ng-container>
    <ng-container *ngSwitchCase="'1'" [ngTemplateOutlet]="mysignup"></ng-container>
    <ng-container *ngSwitchDefault [ngTemplateOutlet]="mylogin"></ng-container>
</ng-container>

<ng-template #mylogin>
    <div class="cc1">
        <!-- <mat-slide-toggle [(ngModel)]="asPartner" color="primary">als Partner anmelden!</mat-slide-toggle> -->
        <span multilang></span>
        <span multilang class="cc2 clicable" (click)="onNoClick()">
            <mat-icon fontIcon="close"></mat-icon>
        </span>
    </div>

    <mat-divider></mat-divider>
    <div class="bodywrp">
        <div class="cc9">
            <span multilang class="cc3">Bitte melden Sie sich an, um fortzufahren</span>
        </div>

        <div class="cc4">
            <form [formGroup]="login">
                <mat-form-field appearance="fill">
                    <mat-label>E-Mail-Adresse</mat-label>
                    <input matInput type="email" placeholder="E-Mail-Adresse" formControlName="email" name="email"
                        required cdkFocusInitial>
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>Passwort</mat-label>
                    <input matInput (keydown.enter)="detectEnter()" placeholder="Passwort"
                        [type]="hide ? 'password' : 'text'" formControlName="password" name="password" required>
                    <button matSuffix mat-icon-button aria-label="Clear" (click)="hide = !hide">
                        <mat-icon>{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
                    </button>
                </mat-form-field>
                <span multilang class="cred">* = Pflichtfeld</span>
            </form>
        </div>

        <div class="cc5">
            <ng-container *ngIf="error?.length > 0">
                <span multilang class="cc6">{{error}}</span>
            </ng-container>
            <div class="cc7">
                <button class="cc8" (click)="loginF()">
                    <ng-container *ngIf="!loading else myloading">
                        Jetzt anmelden
                    </ng-container>
                </button>
                <!-- <button class="cc10">Password vergessen?</button> -->
            </div>

            <ng-container *ngIf="!asPartner">
                <div class="cc11">
                    <span multilang class="cc12">Du hast noch kein Konto?</span>
                    <button class="cc13" (click)="changeMode(1)">Registrieren</button>
                </div>
            </ng-container>

            <ng-container *ngTemplateOutlet="footer"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mysignup>
    <div class="cc15">
        <span multilang class="cc18">Registriere dich</span>
        <span multilang class="cc2 clicable" (click)="onNoClick()">
            <mat-icon fontIcon="close"></mat-icon>
        </span>
    </div>

    <div class="bodywrp">
        <div class="cc16">
            <form [formGroup]="signup">
                <mat-form-field appearance="fill">
                    <mat-label>Geschlecht</mat-label>
                    <mat-select formControlName="salutation" name="salutation">
                        <mat-option value="Herr">Herr</mat-option>
                        <mat-option value="Frau">Frau</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>Vorname</mat-label>
                    <input matInput type="text" placeholder="Vorname" formControlName="firstname" name="firstname"
                        required>
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>Nachname</mat-label>
                    <input matInput type="text" placeholder="Nachname" formControlName="lastname" name="lastname"
                        required>
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>E-Mail-Adresse</mat-label>
                    <input matInput type="email" placeholder="Email" formControlName="email" name="email" required>
                </mat-form-field>
                <mat-form-field appearance="fill">
                    <mat-label>Passwort</mat-label>
                    <input matInput placeholder="Passwort erforderlich" [type]="hide ? 'password' : 'text'"
                        formControlName="password" name="password" required>
                    <<button matSuffix mat-icon-button aria-label="Clear" (click)="hide = !hide">
                        <mat-icon>{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
                        </button>
                        <mat-hint>Das Passwort muss mindestens 8 Zeichen lang sein.</mat-hint>
                </mat-form-field>
                <mat-form-field class="mt5" appearance="fill">
                    <mat-label>Passwort bestätigen</mat-label>
                    <input matInput placeholder="Passwort bestätigen" [type]="hide ? 'password' : 'text'"
                        formControlName="conf_password" name="conf_password" required>
                    <button matSuffix mat-icon-button aria-label="Clear" (click)="hide = !hide">
                        <mat-icon>{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
                    </button>
                </mat-form-field>
            </form>
            <span multilang class="cred">* = Pflichtfeld</span>
        </div>

        <div class="cc5">
            <ng-container *ngIf="error?.length > 0">
                <span multilang class="cc6">{{error}}</span>
            </ng-container>
            <div class="cc7">
                <button class="cc8" (click)="registrierenF()">
                    <ng-container *ngIf="!loading else myloading">
                        Jetzt registrieren
                    </ng-container>
                </button>
            </div>

            <div class="cc19">
                <span multilang class="cc20">Du hast bereits ein Nutzerkonto bei <br>{{data.domainname}}?</span>
                <button class="cc13 mt5" (click)="changeMode(0)">
                    Jetzt Einloggen
                </button>
            </div>

            <ng-container *ngTemplateOutlet="footer"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #footer>
    <ng-container *ngIf="data?.partnerid && data?.partnerid !== 'main'">
        <div class="cc17">
            <span multilang>Partner: <b class="ccu">{{data?.partnerid}}</b></span>
        </div>
    </ng-container>

    <div class="cc14">
        <span multilang>
            Indem Sie fortfahren, erklären Sie sich mit unseren
            <a multilang class="llink" (click)="goto('agb')">Nutzungsbedingungen</a>
            einverstanden und bestätigen, dass Sie unsere
            <a multilang class="llink" (click)="goto('datenschutz')">Datenschutzerklärung</a> gelesen hast.
        </span>
    </div>
</ng-template>

<ng-template #myconfirm>

    <div class="cc21">
        <span multilang class="cc22">Bitte überprüfen Sie Ihre E-Mails. Wir haben Ihnen den Bestätigungscode in 6 Längen
            zugeschickt</span>
        <form class="mt15" [formGroup]="confCode">
            <mat-form-field appearance="fill">
                <mat-label>Bestätigungscode</mat-label>
                <input matInput type="text" placeholder="Bestätigungscode" formControlName="confirmation_code"
                    name="confirmation_code" required>
            </mat-form-field>
        </form>
        <div class="cc23">
            <button class="cc8" (click)="chackconfirmationcode()">
                <ng-container *ngIf="!loading else myloading">
                    <span multilang> Überprüfen</span>
                </ng-container>
            </button>
        </div>
        <ng-container *ngTemplateOutlet="footer"></ng-container>
    </div>

</ng-template>



<ng-template #myloading>
    <mat-spinner diameter="20"></mat-spinner>
</ng-template>